declare let Slider;

export default class {
    public static init($uid: JQuery): void {
        const $items = $('.mainslider__item', $uid);

        $items.each((ix, el) => {
            const $el = $(el);

            if ($el.hasClass('mainslider__item--video')) {
                const video = $('video', $el)[0] as HTMLVideoElement;
                const $mute = $('button', $el);

                $mute.on('click', () => {
                    video.muted = !video.muted;
                });

                video.addEventListener('volumechange', (e) => {
                    const $i = $('i', $mute);
                    $i.toggleClass('fa-volume-mute', video.muted);
                    $i.toggleClass('fa-volume-up', !video.muted);
                });
            }
        });

        const slider = new Slider($uid, {
            fixed: true,
            delay: 4000,
            max: 1,

            canItemChange: (ix: number, time: number) => {
                const $item = $items.eq(ix);

                const isvideo = $item.hasClass('mainslider__item--video');

                if (isvideo) {
                    const video = $('video', $item)[0] as HTMLVideoElement;

                    if (!video.muted) {
                        return $item.hasClass('mainslider__item--video-ended');
                    }
                }

                const duration = ($item.data('duration') || 4) * 1000;

                if (time > duration) {
                    return true;
                }

                return false;
            },

            onChange: (ix) => {
                const $sel = $items.eq(ix);

                $($items).each((ix, el) => {
                    const $item = $(el);

                    if ($item.hasClass('mainslider__item--video')) {
                        const video = $('video', $item)[0] as HTMLVideoElement;
                        video.pause();
                    }
                });

                const isvideo = $sel.hasClass('mainslider__item--video');

                if (isvideo) {
                    const video = $('video', $sel)[0] as HTMLVideoElement;

                    $sel.removeClass('mainslider__item--video-ended');

                    if (!$sel.hasClass('mainslider__item--video-inited')) {
                        $sel.addClass('mainslider__item--video-inited');

                        video.addEventListener('ended', () => {
                            $sel.addClass('mainslider__item--video-ended');
                        });
                    }

                    video.play();
                }
            },
        });
    }
};
